import React, { Component } from 'react';
import { connect } from 'shalala';
import { Row, Col } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../store';
import CancelacionesTicketList from './tickets/CancelacionesTicketList';
import CancelacionesTicketsSearch from './tickets/components/CancelacionesTicketsSearch';
import CancelacionesTicketsActions from './tickets/components/CancelacionesTicketsActions';
import CancelacionesTicketsFilters from './tickets/components/CancelacionesTicketsFilters';
import CancelacionesTicketListItemActions from './tickets/components/CancelacionesTicketListItemActions';

class CancelacionesTickets extends Component {
  state = {
    selectedRowKeys: [],
    selectedRows: [],
  };

  componentDidMount() {
    window.setAppTitle('Cancelaciones');
  }

  handleOnRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/modulos/cancelaciones/${data.id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  handleOnDateChange = (values) => {
    this.props.paginate(values);
  };

  handleOnKeywordChange = (search) => {
    this.props.paginate({ ...search });
  };

  render() {
    const { selectedRowKeys, selectedRows } = this.state;
    const { from, to, search } = this.props.pagination;

    const retryRequestTickets = selectedRows.filter(function (item) {
      return item.status === 3 || item.status === 4;
    });

    return (
      <>
        <Row>
          <Col
            sm="auto"
            md="8"
          >
            {retryRequestTickets.length > 0 && (
              <div className="mr-3 d-inline-flex pb-1">
                <CancelacionesTicketListItemActions
                  selectedRowKeys={selectedRowKeys}
                  selectedRows={selectedRows}
                  retryRequestRows={retryRequestTickets}
                  alignRight={false}
                />
              </div>
            )}

            {(selectedRowKeys.length === 0 || retryRequestTickets.length === 0) && (
              <CancelacionesTicketsSearch
                from={from}
                to={to}
                search={search}
                onDateChange={this.handleOnDateChange}
                onKeywordChange={this.handleOnKeywordChange}
              />
            )}
          </Col>

          <Col
            sm="auto"
            md="4"
            className="text-right"
          >
            {(selectedRowKeys.length === 0 || retryRequestTickets.length === 0) && (
              <CancelacionesTicketsActions
                from={from}
                to={to}
                selectedRowKeys={selectedRowKeys}
                selectedRows={selectedRows}
                alignRight={false}
              />
            )}
          </Col>
        </Row>

        {<CancelacionesTicketsFilters />}

        {Guardian.allows('cancelacion.masiva.listar.tickets') && (
          <CancelacionesTicketList
            onRowClick={this.handleOnRowClick}
            selectedRowKeys={selectedRowKeys}
            selectedRows={selectedRows}
            onRowSelectionChange={this.handleOnRowSelectionChange}
          />
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return store.modulo.cancelaciones.tickets;
};

const mapActions = (actions) => {
  return actions.modulo.cancelaciones.tickets;
};

export default connect(useStore, mapState, mapActions)(CancelacionesTickets);
